import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public url: string | undefined;
  private stopNavigation = new Subject<void>();
  public stopNavigation$ = this.stopNavigation.asObservable();

  public ansokanGreenNotKlarmarkerad = new BehaviorSubject<boolean>(false);
  public ansokanGreenNotKlarmarkerad$ =
    this.ansokanGreenNotKlarmarkerad.asObservable();

  public bedomareProfilInteSparad = new BehaviorSubject<boolean>(false);
  public bedomareProfilInteSparad$ =
    this.bedomareProfilInteSparad.asObservable();

  public confirmNavigation() {
    this.stopNavigation.next();
  }
}
